import styled from '@emotion/styled';
import {
  Button,
  SvgIcon,
  SvgNames,
  tokens,
  Typography,
} from '@sunrun/experience-ui-components';
import { useFeatureFlagEnabled } from '@sunrun/sales-experience-shared/react-feature-flags';
import { FEATURE_FLAGS } from 'constants/FeatureFlags';
import { getUrls } from 'helpers/getUrlHelper';
import { NewDashboardOrgType } from 'helpers/repTypeHelper';

type PerformanceComingSoonProps = {
  orgType: NewDashboardOrgType;
};

const PerformanceComingSoon = ({ orgType }: PerformanceComingSoonProps) => {
  const { oneBaseUrl } = getUrls();
  const newLeaderboardEnabled = useFeatureFlagEnabled(
    FEATURE_FLAGS.NEW_LEADERBOARD_ENABLED,
  );
  const goTo = (page: string) => {
    window.parent.postMessage(
      {
        type: 'COMMAND:CHANGE_URL',
        source: 'Dashboard',
        payload: {
          url: `${oneBaseUrl}/${page}`,
        },
      },
      '*',
    );
  };

  return (
    <Container>
      <ContentContainer>
        <BarChartDiv>
          <IndividualBarChartDiv color={tokens.HEROBLUE_80} height={60} />
          <IndividualBarChartDiv color={tokens.HEROBLUE_70} height={75} />
          <IndividualBarChartDiv color={tokens.HEROBLUE_70} height={100} />
          <IndividualBarChartDiv color={tokens.HEROBLUE_60} height={85} />
        </BarChartDiv>
        <TextContainer>
          <Typography>SCORECARD</Typography>
          <Typography size="small">
            Know the score, crush your goals.
          </Typography>
        </TextContainer>
        {orgType === 'BLOCK' && (
          <Button
            size="sm"
            color="secondary"
            onClick={() => {
              window.open(
                'https://10ay.online.tableau.com/#/site/sunrunbi/views/FusionMobileReportv2_17453693400520/Home-Today?:iid=1',
                '_blank',
              );
            }}>
            Performance in Tableau{' '}
            <SvgIcon height={16} width={16} name={SvgNames.ExternalLink} />
          </Button>
        )}
        {orgType === 'CHAIN' && newLeaderboardEnabled ? (
          <Button
            size="sm"
            color="secondary"
            onClick={() => goTo('performance')}>
            Go to Performance{' '}
            <SvgIcon height={16} width={16} name={SvgNames.ExternalLink} />
          </Button>
        ) : (
          <Button size="sm" color="secondary" onClick={() => goTo('analytics')}>
            Go to Analytics{' '}
            <SvgIcon height={16} width={16} name={SvgNames.ExternalLink} />
          </Button>
        )}
      </ContentContainer>
    </Container>
  );
};

const BarChartDiv = styled.div`
  display: flex;
  gap: 9px;
  height: 100px;
  align-items: flex-end;
`;

const IndividualBarChartDiv = styled.div<{ color: string; height: number }>`
  width: 24px;
  height: ${({ height }) => height}%;
  background-color: ${({ color }) => color};
  border-radius: 4px;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 205px;

  p {
    text-align: center;
  }
`;

const Container = styled.div`
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export { PerformanceComingSoon };
